import { SubscriptionPlanType } from "@coeff/api";

export const getUserEmail = (user: { email?: string }): string => {
  if (!user) {
    return "";
  }
  return user.email ?? "";
};

export const PAID_SUBSCRIPTION_PLAN_TYPES: Array<SubscriptionPlanType> = [
  SubscriptionPlanType.Enterprise,
  SubscriptionPlanType.Plus,
  SubscriptionPlanType.Pro,
  SubscriptionPlanType.Starter,
];

// Display name for an SSO IdP. Takes the raw enum string so both webapp and addon can use it.
export const getIdProviderDisplayName = (idProvider: string | undefined | null): string => {
  if (!idProvider) {
    return "";
  }
  if (idProvider === "entra") {
    return "Microsoft Entra";
  }
  return idProvider[0].toUpperCase() + idProvider.slice(1);
};
